import React from 'react';
import PropTypes from 'prop-types';

function joinDefinitions(svgs) {
  var definitions = '';
  Object.keys(svgs).forEach(function (def) {
    definitions += svgs[def];
  });
  return {
    __html: definitions
  };
}

function SVGDefinitions(_ref) {
  var children = _ref.children,
      data = _ref.data;
  return React.createElement("svg", {
    width: "0",
    height: "0",
    style: {
      'display': 'none'
    },
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, !data.loading && React.createElement("defs", {
    dangerouslySetInnerHTML: joinDefinitions(data.svgs)
  }) // eslint-disable-line react/no-danger
  , React.createElement("defs", null, children));
}

SVGDefinitions.propTypes = {
  /** GraphQL Data for SVG Definitions */
  data: PropTypes.shape({
    loading: PropTypes.bool,
    svgs: PropTypes.objectOf(PropTypes.string)
  }).isRequired
};
SVGDefinitions.defaultProps = {
  data: {
    svgs: {}
  }
};
export default SVGDefinitions;
//# sourceMappingURL=SVGDefinitions.js.map